export default __webpack_public_path__ + "static/media/dashboard-hover.a78aaf8c.svg";